module.exports = __webpack_public_path__ + "static/img/bg1.f492c16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth/img/bg/bg1.jpg
// module id = 1048
// module chunks = 17